<template>
  <div
    class="c-panel c-panel--from-right"
    :class="{'is-open': isOpen, 'white-bg': whiteBg}"
    @keyup.esc="closePanel"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'side-panel',

  data() {
    return {
      //
    };
  },

  mounted() {
    this.popupItem = this.$el;
  },

  methods: {
    closePanel() {
      this.$store.dispatch('CLOSE_PANEL');
    },
  },

  computed: {
    isOpen() {
      return this.$store.state.panelOpen && this.$route.meta.openPanel && this.$route.name != 'unauthorized';
    },
    whiteBg() {
      return this.$route.meta.whiteBg;
    },
  },
};
</script>

<style lang="scss">
.c-panel {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  height: 100%;
  width: 100%;

  visibility: hidden;
  transition: visibility 0s 0.6s;

  z-index: 70;
}

.c-panel::after {
  /* overlay layer */
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  cursor: pointer;
  transition: background 0.3s 0.3s;
  z-index: -1;
}

.c-panel.c-panel.is-open {
  visibility: visible;
  transition: visibility 0s 0s;
}

.c-panel.c-panel.is-open::after {
  background: rgba(0, 0, 0, 0.6);
  transition: background 0.3s 0s;
}

.c-panel--from-right .c-panel__header {
  right: 0;
}

.c-panel--from-left .c-panel__header {
  left: 0;
}

.c-panel.is-open .c-panel__header {
  transition: transform 0.3s 0.3s;
  transform: translateY(0px);
}

.c-panel--from-right .c-panel__inner {
  right: 0;
  transform: translate3d(100%, 0, 0);
}

.c-panel--from-left .c-panel__inner {
  left: 0;
  transform: translate3d(-100%, 0, 0);
}

.c-panel.is-open .c-panel__inner {
  transform: translate3d(0, 0, 0);
  transition-delay: 0s;
}

.white-bg {
  .c-panel__content {
    background: white !important;
  }
}
</style>
